export default "__VITE_ASSET__DxaJv2Zc__"